import React, {Component, ReactNode} from 'react'
import NatResidentUserSelectionComponent
    from '../../../__NoAutomatedTests/components/common/admin/NatResidentUserSelectionComponent'
import {SelectedUserList} from '../../../__NoAutomatedTests/components/facilityReserve/repository/NatGetFacilityReserve'
import NatRidgeRepo from '../../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import equal from 'fast-deep-equal'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminDefaultButton} from '../../../styledComponents/adminPage/Buttons'
import {HKConstants} from '../../../HKConstants'
import {Messages} from '../../../Messages'
import {Box, TableRow} from '@mui/material'
import {DeleteLink} from '../../../styledComponents/adminPage/Links'
import {InnerMiniTable, InnerMiniTableBody, InnerMiniTableCell} from '../../../styledComponents/adminPage/Table'
import NatRoomToResidentRepo
    from '../../../__NoAutomatedTests/components/roomToResident/repository/NatRoomToResidentRepo'
import {AsyncCommunicationProps} from '../../shared/hoc/withAsyncCommunication'
import {ACCESS_CONTROL_MANAGER, SELECT_USER_TYPE} from '../../../CodeMaster'
import {SelectedUser} from '../../../__NoAutomatedTests/components/common/resident/NatResidentSelectedUser'
import {Nullable} from '../../../app/TypeHelpers'
import {
    ExcudeResidentUserInfo,
    ResidentUserInfo,
} from '../../../__NoAutomatedTests/components/roomToResident/repository/NatGetRoomToResident'
import moment from 'moment'
import {Location, NavigateFunction} from 'react-router-dom'


interface Props {
    selectedUserList: SelectedUserList[]
    onChangeUserList: (users: SelectedUserList[]) => void
    excludeSelectedUser: Nullable<ResidentUserInfo>
    roomToResidentRepo: NatRoomToResidentRepo
    ridgeRepo: NatRidgeRepo
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction
    condominiumCd: string
    location: Location
    validPeriodCriteriaDate: Nullable<moment.Moment>
    accessControlManager: ACCESS_CONTROL_MANAGER
}

interface State {
    open: boolean
    selectedUserList: SelectedUserList[]
}

class AdminReserveUsersRoomNumberInput extends Component<Props & AsyncCommunicationProps, State> {

    constructor(props: Readonly<Props & AsyncCommunicationProps>) {
        super(props)

        this.state = {
            open: false,
            selectedUserList: props.selectedUserList,
        }

        this.handleAddButtonClick = this.handleAddButtonClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleUpdateSelectedUsers = this.handleUpdateSelectedUsers.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        const {selectedUserList} = this.props
        if (!equal(prevProps.selectedUserList, selectedUserList)) {
            this.setState({selectedUserList})
        }
    }

    handleCancel(): void {
        this.setState({open: false})
    }

    handleUpdateSelectedUsers(selectedUserList: SelectedUserList[]): void {
        this.setState(
            {open: false, selectedUserList: selectedUserList},
            () => {
                this.props.onChangeUserList(this.state.selectedUserList)
            },
        )
    }

    handleAddButtonClick(): void {
        this.setState({open: true})
    }

    deleteLinkClick = (cardKeyUser: SelectedUser) => (_: React.MouseEvent<HTMLElement>) => {
        this.setState((prevState) => {
            return {
                selectedUserList: prevState.selectedUserList.filter(user => {
                    return user.ridgeCd !== cardKeyUser.ridgeCd || user.roomNumber !== cardKeyUser.roomNumber
                }),
            }
        }, () => {
            this.props.onChangeUserList(this.state.selectedUserList)
        })
    }

    private renderSelectedUserList(): ReactNode {
        const {selectedUserList} = this.state
        if (selectedUserList.length === 0) {
            return null
        }

        return <InnerMiniTable>
            <InnerMiniTableBody>
                {
                    [...selectedUserList]
                        .sort((a, b) => {
                            const aName = `${a.ridgeCd}${a.roomNumber}`
                            const bName = `${b.ridgeCd}${b.roomNumber}`
                            if (aName === bName) {
                                return 0
                            }
                            return (aName > bName) ? 1 : -1
                        }).map((item, index) => (
                        <TableRow key={index}>
                            <InnerMiniTableCell>
                                {`${item.ridgeName} ${item.roomNumber}`}
                            </InnerMiniTableCell>
                            <InnerMiniTableCell>
                                <DeleteLink onClick={this.deleteLinkClick(item)}>
                                    削除
                                </DeleteLink>
                            </InnerMiniTableCell>
                        </TableRow>
                    ))
                }
            </InnerMiniTableBody>
        </InnerMiniTable>
    }

    render(): ReactNode {
        const {
            condominiumCd,
            excludeSelectedUser,
            roomToResidentRepo,
            ridgeRepo,
            eventEmitter,
            navigate,
            asyncCallFunction,
            location,
            accessControlManager,
        } = this.props
        const {selectedUserList} = this.state
        let excudeResidentUserInfo: Nullable<ExcudeResidentUserInfo> = null
        if (excludeSelectedUser !== null) {
            excudeResidentUserInfo = {
                excludeCondominiumCd: condominiumCd,
                excludeRidgeCd: excludeSelectedUser.ridgeCd,
                excludeRoomNumber: excludeSelectedUser.roomNumber,
            }
        }

        return (<>
            <LeftRowFlexContainer>
                同時入室番号
                <Box ml={'20px'}>
                    <AdminDefaultButton size={'small'} onClick={this.handleAddButtonClick}>
                        追加する
                    </AdminDefaultButton>
                </Box>
            </LeftRowFlexContainer>
            {this.renderSelectedUserList()}

            {
                this.state.open && <>
                    <Box mt={'10px'}>
                        {Messages.IFACC0005.toString(HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS)}
                    </Box>
                    <NatResidentUserSelectionComponent
                        selectedCondominiumCd={condominiumCd}
                        selectUserType={SELECT_USER_TYPE.ROOM_NUMBER.value}
                        mainUserFlag={true}
                        cardKeyNumberIsNotNullFlg={accessControlManager === ACCESS_CONTROL_MANAGER.ODEC_TECHNO}
                        invalidUserSelectFlag={true}
                        closeSelectResidentUserDiaLog={this.handleCancel}
                        setSelectedExclusionResidentUserInfo={this.handleUpdateSelectedUsers}
                        selectedUserList={selectedUserList}
                        maxSelectableKeyNumber={Number(HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS)}
                        excudeResidentUserInfo={excudeResidentUserInfo}
                        roomToResidentRepo={roomToResidentRepo}
                        ridgeRepo={ridgeRepo}
                        asyncCallFunction={asyncCallFunction}
                        eventEmitter={eventEmitter}
                        navigate={navigate}
                        location={location}
                        validPeriodCriteriaDate={this.props.validPeriodCriteriaDate}
                    />
                </>
            }
        </>)
    }
}

export default AdminReserveUsersRoomNumberInput
